import { render, staticRenderFns } from "./ModifierFields.vue?vue&type=template&id=715338c6"
import script from "./ModifierFields.vue?vue&type=script&lang=js"
export * from "./ModifierFields.vue?vue&type=script&lang=js"
import style0 from "./ModifierFields.vue?vue&type=style&index=0&id=715338c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports